import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
    selector: "edp-footer",
    templateUrl: "./edp-footer.component.html",
    styleUrls: ["edp-footer.component.scss"],
    encapsulation: ViewEncapsulation.None,
})
export class EdpFooterComponent implements OnInit, OnDestroy {
    private unsubscribe = new Subject();
    public faqsLink = this.translate.instant("pt.edp.edponline.footer.faqs.link");
    public policyLink = this.translate.instant("pt.edp.edponline.footer.privacy.policy.link");
    public policyAndCookies = this.translate.instant("pt.edp.edponline.footer.policy_privacy_and_policy_cookies");

    public getClickData(type: string, url: string): { formModal; interactionName; interactionLocation } {
        switch (type) {
            case "edp":
                return { formModal: url, interactionName: "EDP.pt", interactionLocation: "footer-interno" };
            case "store":
                return { formModal: url, interactionName: "Lojas e agentes", interactionLocation: "footer-interno" };
            case "contacts":
                return { formModal: url, interactionName: "Contactos EDP", interactionLocation: "footer-interno" };
            case "faqs":
                return { formModal: url, interactionName: "Faqs", interactionLocation: "footer-interno" };
            case "help":
                return { formModal: url, interactionName: "Apoio ao cliente", interactionLocation: "footer-interno" };
            case "complains":
                return { formModal: url, interactionName: "Livro de reclamações", interactionLocation: "footer-interno" };
            case "youtube":
            case "instagram":
            case "linkedin":
                return { formModal: url, interactionName: type, interactionLocation: "footer-social" };
            case "apple":
                return { formModal: url, interactionName: "App Store", interactionLocation: "footer-download" };
            case "google":
                return { formModal: url, interactionName: "Google Play", interactionLocation: "footer-download" };
            default:
                return;
        }
    }

    constructor(private readonly store: Store<IAppState>, private translate: TranslateService) {}

    ngOnInit(): void {
        this.store
            .select(getUser)
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(user => {
                if (!!user && !!user.isCaixa()) {
                    this.faqsLink = this.translate.instant("pt.edp.edponline.footer.faqs.link.caixa");
                    this.policyLink = this.translate.instant("pt.edp.edponline.footer.privacy.policy.link.caixa");
                    this.policyAndCookies = this.translate.instant("pt.edp.edponline.footer.privacy.policy.and.policy.cookies.caixa");
                }
            });
    }
    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
